// 修复路由页面加载失败或者莫名跳转问题
export default function (location: Location) {
  const path = `${location.origin}/akf`
  const regx = new RegExp(path);
  const currentPath = location.origin + location.pathname
  return regx.test(currentPath);
  // return new RegExp('akf').test(location.href);
}
